import styled from "styled-components";

export const TextContainer = styled.div `
color: #5b6278;
width:65%;
text-align:left;
padding:1rem;

`